import {
    BUILDING_CONSTRUCTION_TYPES,
    BUILDING_DESCRIPTION_PROPERTY_TYPES,
    BUILDING_DESCRIPTION_PROPERTY_TYPES_WITH_UNIT_COUNT,
} from 'cpool-constants';
import { z } from 'zod';

import { schemaBigDecimal, schemaInteger } from '../../../utils/schema.utils';

export const schemaBaubeschreibungAnschriftUndObjektart = z
    .object({
        anschrift: z
            .object({
                hausnummer: z.string().nullish().default(null),
                ort: z.string().nullish().default(null),
                plz: z.string().nullish().default(null),
                strasse: z.string().nullish().default(null),
            })
            .default({}),
        baujahr: schemaInteger.min(1000).max(9999).nullish().default(null),
        bauweise: z.nativeEnum(BUILDING_CONSTRUCTION_TYPES).nullish().default(null),
        denkmalschutz: z.boolean().nullish().default(null),
        etage: schemaInteger.nullish().default(null),
        fremdgenutzteWohnflaeche: schemaInteger.nonnegative().nullish().default(null),
        geschaetzterWert: schemaBigDecimal.nonnegative().nullish().default(null),
        grundstuecksgroesse: schemaInteger.nonnegative().nullish().default(null),
        objektart: z.nativeEnum(BUILDING_DESCRIPTION_PROPERTY_TYPES).nullish().default(null),
        pacht: z.boolean().nullish().default(null),
        wohneinheitenAnzahl: schemaInteger.nonnegative().nullish().default(null),
        wohnflaeche: schemaInteger.nonnegative().nullish().default(null),
    })
    .transform((data) => ({
        ...data,
        etage: data.objektart === BUILDING_DESCRIPTION_PROPERTY_TYPES.EIGENTUMSWOHNUNG ? data.etage : null,
        wohneinheitenAnzahl:
            data.objektart && BUILDING_DESCRIPTION_PROPERTY_TYPES_WITH_UNIT_COUNT.has(data.objektart)
                ? data.wohneinheitenAnzahl
                : null,
    }));

export type SchemaBaubeschreibungAnschriftUndObjektart = z.infer<typeof schemaBaubeschreibungAnschriftUndObjektart>;
